import { render } from "./HoxtonTheBrandComponent.vue?vue&type=template&id=b8f832c4&scoped=true"
import script from "./HoxtonTheBrandComponent.vue?vue&type=script&lang=js"
export * from "./HoxtonTheBrandComponent.vue?vue&type=script&lang=js"

import "./HoxtonTheBrandComponent.vue?vue&type=style&index=0&id=b8f832c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f832c4"]])

export default __exports__